export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_01_45_01.Still007.76118c3a.jpg";